export enum EPunterStatus {
  Normal = 'Normal',
  Suspended_KYC = 'Suspended_KYC',
  Closed_Customer_Requested = 'Closed_Customer_Requested',
  Temporary_Self_Exclusion = 'Temporary_Self_Exclusion',
  Permanent_Self_Exclusion = 'Permanent_Self_Exclusion',
}
